import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const OrderSuccessPage = () => {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const response = await axios.get(`${API}/orders/${orderId}`);
        setOrder(response.data);
      } catch (error) {
        console.error('Error fetching order:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchOrder();
  }, [orderId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-slate-500">Loading...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-2xl mx-auto px-6 py-12"
      >
        <div className="bg-white rounded-2xl shadow-lg p-12 text-center">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>

          <h1 className="text-4xl font-outfit font-bold text-slate-900 mb-4">
            Order Placed Successfully!
          </h1>
          
          <p className="text-lg text-slate-600 font-dm-sans mb-8">
            Thank you for your order. We'll start processing it right away.
          </p>

          {order && (
            <div className="bg-slate-50 rounded-lg p-6 mb-8 text-left">
              <div className="space-y-3">
                <div className="flex justify-between">
                  <span className="text-slate-600">Order ID</span>
                  <span className="font-dm-sans font-semibold" data-testid="order-id">{order.id}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-600">Total Amount</span>
                  <span className="font-dm-sans font-semibold text-[#0047AB]">
                    ₹{order.total_amount.toLocaleString()}
                  </span>
                </div>
                <div className="flex justify-between">
                  <span className="text-slate-600">Status</span>
                  <span className="font-dm-sans font-semibold text-green-600">
                    {order.payment_status === 'paid' ? 'Paid' : 'Pending'}
                  </span>
                </div>
              </div>
            </div>
          )}

          <div className="flex gap-4 justify-center">
            <Button
              onClick={() => navigate('/products')}
              variant="outline"
              data-testid="continue-shopping-btn"
            >
              Continue Shopping
            </Button>
            <Button
              onClick={() => navigate('/')}
              className="bg-[#0047AB] hover:bg-[#003380]"
            >
              Back to Home
            </Button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default OrderSuccessPage;